import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import BenefitsSection from "./components/BenefitsSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonSection from "./components/ComparisonSection";
import SafetySection from "./components/SafetySection";
import SeoArticlesSection from "./components/SeoArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.life';

  return (
    <main>
      <Navbar />
      <HeroSection />
      <BenefitsSection />
      <CategoryGrid />
      <ComparisonSection />
      <SafetySection />
      <SeoArticlesSection />
      <FAQSection />
      <CTASection />
      <Footer />

      {/* Schema.org WebPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Hoobuy Spreadsheet em Português 2026",
            "description": "Descubra a melhor Hoobuy Spreadsheet em português. Links verificados, produtos populares, guias completos e planilhas atualizadas para comprar com segurança.",
            "url": `${siteUrl}/`,
            "inLanguage": "pt-PT",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Hoobuy Life",
              "url": `${siteUrl}/`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Início",
                  "item": `${siteUrl}/`
                }
              ]
            }
          }),
        }}
      />
    </main>
  );
}